import type { Role } from '@chemoflow/contracts';

export type ViewName = 'clerk' | 'rx' | 'nurse' | 'board' | 'stats' | 'admin' | 'monitor';

export const VIEW_NAMES: ViewName[] = [
  'clerk',
  'rx',
  'nurse',
  'board',
  'stats',
  'admin',
  'monitor',
];

export interface RoleProfile {
  label: string;
  dept: string;
  home: ViewName;
  icon: string;
}

export const ROLE_PROFILE: Record<Role, RoleProfile> = {
  clerk: { label: '外来クラーク', dept: '外来クラーク', home: 'clerk', icon: 'stethoscope' },
  pharm: { label: '薬剤師', dept: '薬剤部（調製室）', home: 'rx', icon: 'medication' },
  nurse: { label: '看護師', dept: '化学療法室', home: 'nurse', icon: 'bed' },
  admin: { label: '管理者', dept: '管理', home: 'board', icon: 'settings' },
};

/** 部署専用の画面と、それを操作できるロール。他部署の画面は開かない。 */
export const VIEW_OWNER: Partial<Record<ViewName, Role>> = {
  clerk: 'clerk',
  rx: 'pharm',
  nurse: 'nurse',
};

export const homeView = (role: Role): ViewName => ROLE_PROFILE[role].home;

/** 閲覧はできるが操作はできない状態か（要件10-2：閲覧は全部署分）。 */
export const isReadonly = (view: ViewName, role: Role): boolean => {
  const owner = VIEW_OWNER[view];
  return Boolean(owner) && owner !== role && role !== 'admin';
};

export const canOpen = (view: ViewName, role: Role): boolean => {
  const owner = VIEW_OWNER[view];
  return !owner || owner === role || role === 'admin';
};
